import React, { Component } from "react";
import PropTypes from "prop-types";
import { ConnectedRouter } from "connected-react-router";
import { Provider } from "react-redux";
import RootContainer from "./rootContainer";
import { PersistGate } from "redux-persist/integration/react";
import persistor from "../store/configureStore";

export default class Root extends Component {
  componentDidMount() {
    this.handleMessage = (event) => {
      if (event.origin !== "https://solutions.xoxoday.com") return; // Security check

      if (event.data.action === "navigate") {
        window.location.href = event.data.url;
      }
    }

    window.addEventListener("message", this.handleMessage);
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.handleMessage);
  }

  render() {
    const { store, history, persistor } = this.props;
    return (
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ConnectedRouter history={history}>
            <RootContainer history={history} location={history.location} />
          </ConnectedRouter>
        </PersistGate>
      </Provider>
    );
  }
}

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};
